/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Empty_BodyInputs */

const en_contact_empty_body = /** @type {(inputs: Contact_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trainer has not added a phone, email or address yet.`)
};

const pl_contact_empty_body = /** @type {(inputs: Contact_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener nie dodał jeszcze telefonu, maila ani adresu.`)
};

/**
* | output |
* | --- |
* | "The trainer has not added a phone, email or address yet." |
*
* @param {Contact_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_empty_body = /** @type {((inputs?: Contact_Empty_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Empty_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_empty_body(inputs)
	return en_contact_empty_body(inputs)
});